import { Injectable } from 'angular-ts-decorators';

import { map } from 'lodash';

/**
 * Language info object
 */
export type ILanguageInfoObject = {
  code: string;
  name: string;
};

type ILanguageMap = {
  [key: string]: string;
};

/**
 * # Languages
 * Service that wraps the language list NPM module https://www.npmjs.com/package/iso-countries-languages
 */
@Injectable('languages')
export class Languages {
  private languageKeys: { [key: string]: ILanguageMap };

  constructor(private language: any) {
    'ngInject';

    this.languageKeys = {
      // supported i18n list
      'nl-nl': <ILanguageMap>(
        require('iso-countries-languages/res/languages/nl.json')
      ),
      'en-gb': <ILanguageMap>(
        require('iso-countries-languages/res/languages/en.json')
      ),
      'fr-fr': <ILanguageMap>(
        require('iso-countries-languages/res/languages/fr.json')
      ),
      'de-de': <ILanguageMap>(
        require('iso-countries-languages/res/languages/de.json')
      ),
      'it-it': <ILanguageMap>(
        require('iso-countries-languages/res/languages/it.json')
      ),
      'es-es': <ILanguageMap>(
        require('iso-countries-languages/res/languages/es.json')
      ),
    };
  }

  private getCurrentLanguageList(): ILanguageMap {
    if (this.languageKeys[this.language.current]) {
      return this.languageKeys[this.language.current];
    } else {
      return this.languageKeys['en-gb'];
    }
  }

  /**
   * Returns an array of languages in a current language
   * @returns {Array<object>}
   * language in a form:
   * {
   *   code: 2 letters language code
   *   name: translated name of the language
   * }
   */
  getList(): ILanguageInfoObject[] {
    const list = this.getCurrentLanguageList();

    return map(list, (name, code) => {
      return {
        code,
        name,
      };
    });
  }

  /**
   * Returns a language name when an ISO code is provided
   * @param {String} code the ISO language code
   * @returns {String}
   * languages
   */
  getLanguageNameByCode(code: string): string {
    const list = this.getCurrentLanguageList();

    return list[code] ? list[code] : '';
  }
}
